import React from 'react';
import VideoItem from './VideoItem';
import './Video.css'

const VideoList = ({videos , handleVideoSelect}) => {

	const renderedVideos =  videos.map((video) => {
		return <VideoItem key={video.id.videoId} video={video} handleVideoSelect={handleVideoSelect} />
	});


	return <div className='listOfVideos'>{renderedVideos}</div>;
};
export default VideoList;